import { isEmpty } from 'lodash';
import dynamic from 'next/dynamic';
import React, { useMemo } from 'react';
import type { ReactNode } from 'react';

import { useAffiliateInfo, useUser } from '../../store/hooks/users';
import { DefaultLayout } from '../DefaultLayout';

const UserLayout = dynamic(() => import('../UserLayout'), {
  ssr: false,
});

export interface MainLayoutProps {
  children?: ReactNode;
}

export const MainLayout = ({ children }: MainLayoutProps) => {
  const user = useUser();
  const affiliateInfo = useAffiliateInfo();

  const View = useMemo(
    () => (!isEmpty(user) && !isEmpty(affiliateInfo) ? UserLayout : DefaultLayout),
    [user, affiliateInfo],
  );

  return <View>{children}</View>;
};
